module.exports = __webpack_public_path__ + "static/automatic-ai_4-ba928046717791437290ef384ca6495c.jpg";